import React, { useState, useEffect } from "react";
import { Box, Button, Container, styled } from "@mui/material";
import DesktopMenu from "./component/DesktopMenu";
import MobileMenu from "./component/MobileMenu";
import { ViewDocs } from "../../../links";



const LockerMenu = (props) => {
  // const [topPosition, setTopPosition] = useState(40);
  // const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);

  // const handleScroll = () => {
  //   const currentScrollPos = window.pageYOffset;
  //   const visible = prevScrollPos > currentScrollPos;

  //   setTopPosition(visible ? 40 : -100);
  //   setPrevScrollPos(currentScrollPos);
  // };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [prevScrollPos]);

  const menuList = [
    {
      title: "Home",
      link: "/#home",
      zindex: "10999999",
    },
    {
      title: "About",
      link: "/#about",
      zindex: "109999",
    },
    {
      title: "Autonomous Browsing",
      link: "/#AutonomousBrowsing",
      zindex: "109999",
    },
    {
      title: "$ZEPHYR",
      link: "https://dexscreener.com/solana/evxu7aog8kdrwh4115jxxnqjl7sh6xryz37l1xj3bsps",
      zindex: "109999",
    },
    {
      title: "Docs",
      link: ViewDocs,
      zindex: "109999",
    },  

    {
      title: (
    <Button
      href="https://zephyrbrowser.com/browser/zephyr-1.0.0.exe"
      sx={{
        fontSize: "17px !important",
        fontFamily: "primary1",
        fontWeight: "600 !important",
        textTransform: "none !important",
        minWidth: "125px",
      
    
      }}
    >
         <span className="default-label">Download Now</span>
         {/* <span className="hover-label">Coming Soon</span> */}
        </Button>
      ),
      link: "#",
      p: "0 8px 0 5px",
    }, 
 

  ];

  return (
    < >
      <DesktopMenu menuList={menuList} />
      <Container maxwidth="md">
      <MobileMenu menuList={menuList} />
      </Container>
    </>
  );
};

export default LockerMenu;
